import { Padding } from '../../utils/editorReactIcons';
export { Padding };
export default Padding;
